module.exports = __webpack_public_path__ + "img/info-mobile.aae99644.svg";